import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useCanjeModal } from '../context/CanjeModalContext';
import CanjeMovementsView from './CanjeMovementsView';
import CanjeScriptureView from './CanjeScriptureView';

const CanjeModalBody: FC = () => {
  const { data } = useCanjeModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        {data.scriptureView ? <CanjeScriptureView /> : <CanjeMovementsView />}
      </div>
    </Modal.Body>
  );
};

export default CanjeModalBody;
